import { colors } from '../../colors';
var anchor = {
  anchorColor: colors.cornflowerBlue
};
export default anchor;